<template>
    <v-card
        class="soli-round w-full"
        v-if="teacher"
        @click.native="$emit('click')"
        flat
        :outlined="$vuetify.breakpoint.smAndUp && !floating"
    >
        <v-container>
            <SoliAvatarBtn
                :outlined="outlined"
                @click="[$emit('input', teacher), (dialog = true)]"
                :avatar="teacher.profile_photo_url"
                :title="teacher.name"
                size="64"
                blueShadow
                :ripple="false"
                :moreInfo="!!(expand && teacher.bio)"
                :disabled="disabled"
                autoHideImage
                :subtitleBottom="`${
                    teacher.pronouns ? teacher.pronouns + ' | ' : ''
                }${
                    teacher.instruments.length > 3
                        ? teacher.instruments
                              .filter((e, idx) => 3 > idx)
                              .map((i) => ' ' + i.name) + '...'
                        : teacher.instruments.map((i) => ' ' + i.name)
                }`"
            >
                <template>
                    <SoliTeacherCert
                        v-if="teacher.certification_level"
                        :teacher="teacher"
                /></template>

                <TeacherInfo
                    v-if="selectedInstrument"
                    v-model="dialog"
                    @close="dialog = false"
                    :teacher="teacher"
                    :selectedInstrument="selectedInstrument"
                ></TeacherInfo>
            </SoliAvatarBtn>
            <v-container class="pa-2" v-if="value && hasOpenTimes">
                <div
                    v-for="intervals in intervalGroup"
                    :key="intervals.assignment_id"
                >
                    <SoliTime
                        v-if="intervals.openTimes.length"
                        label="Start Time"
                        ref="soliTime"
                        narrow
                        :intervals="intervals.openTimes"
                        :loading="loading"
                        :select="false"
                        @input="
                            $emit('inputTime', {
                                teacher: teacher,
                                time: $event,
                                assignment_id: intervals.assignment_id,
                            })
                        "
                    ></SoliTime>
                </div>
            </v-container>
            <v-container v-if="value && !hasOpenTimes && !loading">
                <v-col class="soli-grey py-0">
                    Sorry, no times are available for this selection
                </v-col></v-container
            ></v-container
        >

        <v-divider
            class="mt-4"
            v-if="!hideDivider && ($vuetify.breakpoint.xs || floating)"
        />
    </v-card>
</template>

<script>
import TeacherInfo from "../Teachers/TeacherInfo.vue";

export default {
    components: {
        TeacherInfo,
    },
    props: {
        teacher: {
            type: Object,
            default: () => {},
        },
        expand: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        selectedInstrument: {
            type: Number,
            default: null,
        },
        outlined: {
            type: Boolean,
            default: true,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        floating: {
            type: Boolean,
            default: false,
        },
        intervalGroup: {
            type: Array,
            default: null,
        },
        assignment_id: {
            type: String,
            default: null,
        },
        value: {
            type: String,
            default: "",
        },
        hideDivider: {
            type: Boolean,
            default: false,
        },
        simStudentView: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            //expanded: null,
            dialog: false,
        };
    },
    methods: {
        /*getBio() {
            return axios
                .get(`/api/teacher-info/${this.teacher.id}/bio`)
                .then((resp) => {
                    console.log(resp.data);
                    return JSON.stringify(resp.data);
                });
        },*/
    },
    computed: {
        /*getIntervals() {
            if (!this.simStudentView) return this.intervalGroup;

            const compare = moment(new Date(this.value));
            const now = moment();
            const firstPossibleTime = now.add(36, "hours");

            if (!compare.isSame(firstPossibleTime, "day")) {
                return this.intervalGroup;
            }

            let intervalGroup = this.intervalGroup;

            intervalGroup.forEach((group, idx) => {
                intervalGroup[idx].openTimes = group.openTimes.filter(
                    (time) => {
                        let format = moment(new Date(this.value + " " + time));
                        if (format.isBefore(firstPossibleTime)) return;
                        return time;
                    }
                );
            });

            return intervalGroup;
        },*/
        hasOpenTimes() {
            return this.intervalGroup.some((e) => e.openTimes.length);
        },
    },
};
</script>
